var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPossibleLogoWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 21,
    viewBox: "0 0 107 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_268_498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0433 0.703003H0V10.7356H10.0433V0.703003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0433 10.7357H0V20.7683H10.0433V10.7357Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7643 0.679688H21.3007C25.1181 0.679688 27.6445 2.97563 27.6445 6.47748C27.6445 9.97933 25.1187 12.2746 21.3013 12.2746H16.377V20.7708H13.7643V0.679688ZM21.0425 10.0077C23.4537 10.0077 25.0318 8.60088 25.0318 6.47748C25.0318 4.35408 23.4537 2.94666 21.0425 2.94666H16.3763V10.0077H21.0425Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.246 13.5379C27.246 9.17527 30.3171 6.07581 34.5645 6.07581C38.812 6.07581 41.8837 9.17527 41.8837 13.5379C41.8837 17.9006 38.7836 21.0001 34.5645 21.0001C30.3171 21.0001 27.246 17.9006 27.246 13.5379ZM34.5645 18.8477C37.3775 18.8477 39.3863 16.6664 39.3863 13.5379C39.3863 10.3805 37.3775 8.19921 34.5645 8.19921C31.7516 8.19921 29.7428 10.3805 29.7428 13.5379C29.7428 16.6664 31.7522 18.8477 34.5645 18.8477Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9164 16.0347H45.3849C45.5857 17.8715 46.791 18.9049 48.6594 18.9049C50.4389 18.9049 51.556 18.1297 51.556 16.6379C51.556 13.0794 43.2904 15.3155 43.2904 9.97931C43.2904 7.76964 45.2992 6.07507 48.1978 6.07507C51.3552 6.07507 53.3614 7.6248 53.7663 10.4088H51.2979C51.097 8.94469 49.8338 8.17014 48.1978 8.17014C46.7916 8.17014 45.701 8.74381 45.701 9.89178C45.701 13.1663 54.0245 10.7532 54.0245 16.5794C54.0245 19.1914 51.7859 20.9993 48.6575 20.9993C44.9258 21 43.06 18.5321 42.9164 16.0347Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1348 16.0347H57.6033C57.8041 17.8715 59.0094 18.9049 60.8778 18.9049C62.6574 18.9049 63.7745 18.1297 63.7745 16.6379C63.7745 13.0794 55.5088 15.3155 55.5088 9.97931C55.5088 7.76964 57.5176 6.07507 60.4168 6.07507C63.5736 6.07507 65.5805 7.6248 65.9848 10.4088H63.5163C63.3154 8.94469 62.0528 8.17014 60.4168 8.17014C59.01 8.17014 57.9194 8.74381 57.9194 9.89178C57.9194 13.1663 66.243 10.7532 66.243 16.5794C66.243 19.1914 64.0043 20.9993 60.8759 20.9993C57.1442 21 55.2783 18.5321 55.1348 16.0347Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.054 6.30493H70.5224V20.7708H68.054V6.30493Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.348 18.3887V20.7709H72.8795V0.572754H75.348V8.65767C76.1805 7.07898 78.1893 6.07584 80.3423 6.07584C84.676 6.07584 87.5462 9.06069 87.5462 13.538C87.5462 18.0153 84.676 21.0001 80.3423 21.0001C78.2182 21.0001 76.1805 19.9667 75.348 18.3887ZM80.1968 18.8767C82.9808 18.8767 85.0456 16.6954 85.0456 13.538C85.0456 10.3806 82.9789 8.19924 80.1968 8.19924C77.3555 8.19924 75.348 10.3806 75.348 13.538C75.348 16.6664 77.3574 18.8767 80.1987 18.8767H80.1968Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.145 0.550049H91.6135V20.7708H89.145V0.550049Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2124 13.5379C93.2124 9.17527 96.1973 6.07581 100.302 6.07581C104.722 6.07581 107.48 9.51972 106.932 13.8534H95.7092C95.8245 16.9245 97.6613 18.8767 100.388 18.8767C102.483 18.8767 103.861 17.8143 104.32 16.15H106.788C106.271 18.9623 103.804 20.9988 100.474 20.9988C96.1973 21.0001 93.2124 17.9006 93.2124 13.5379ZM104.435 11.9007C104.435 9.60473 102.741 8.16961 100.302 8.16961C97.9485 8.16961 96.3408 9.49201 95.8528 11.9007H104.435Z",
    fill: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2599 0.534302C70.2354 0.534302 70.9532 1.22321 70.9532 2.17156C70.9532 3.11991 70.2354 3.80882 69.2599 3.80882C68.3154 3.80882 67.595 3.11991 67.595 2.17156C67.595 1.22321 68.3128 0.534302 69.2599 0.534302Z",
    fill: "#1C1C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_268_498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 20.4658,
    fill: "white",
    transform: "translate(0 0.534302)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPossibleLogoWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PossibleLogoWhite.0065a62584a8ecea903d3f049a6f2bb7.svg";